import React, { useState } from "react";
import ReactDOM from "react-dom";
import { FaGlobe, FaTimes, FaCheck } from "react-icons/fa";
import "./LanguageModal.css";

const languages = [
  { code: "en", label: "English", sub: "EN" },
  { code: "hi", label: "हिंदी", sub: "HI" },
  { code: "mr", label: "मराठी", sub: "MR" },
  { code: "gu", label: "ગુજરાતી", sub: "GU" },
  { code: "kn", label: "ಕನ್ನಡ", sub: "KN" },
  { code: "te", label: "తెలుగు", sub: "TE" },
  { code: "bn", label: "বাংলা", sub: "BN" },
  { code: "es", label: "Español", sub: "ES" },
];

export default function LanguageModal({ show, onClose, onSelectLang }) {
  const [selectedLang, setSelectedLang] = useState("en");

  if (!show) return null;

  const applyLanguage = () => {
    const googleSelect = document.querySelector("select.goog-te-combo");
    if (googleSelect) {
      googleSelect.value = selectedLang;
      googleSelect.dispatchEvent(new Event("change"));
    }
    onSelectLang?.(selectedLang);
    onClose();
  };

  return ReactDOM.createPortal(
    <div className="lang-modal-overlay" onClick={onClose}>
      <div className="lang-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="lang-modal-header">
          <div className="lang-modal-title-group">
            <FaGlobe className="lang-globe-icon" />
            <div>
              <h3>Select Language</h3>
              <p>Choose your preferred display language</p>
            </div>
          </div>
          <button className="lang-close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="lang-modal-body">
          <div className="lang-grid">
            {languages.map(({ code, label, sub }) => (
              <button
                key={code}
                className={`lang-card ${selectedLang === code ? "active" : ""}`}
                onClick={() => setSelectedLang(code)}
              >
                <div className="lang-card-content">
                  <span className="lang-label">{label}</span>
                  <span className="lang-sub">{sub}</span>
                </div>
                {selectedLang === code && <FaCheck className="lang-check-icon" />}
              </button>
            ))}
          </div>
        </div>

        <div className="lang-modal-footer">
          <button className="lang-btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="lang-btn-primary" onClick={applyLanguage}>
            Confirm Language
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
